/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAdsClickIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-ads-click"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 8.32Q10.47 8.32 9.4 9.4Q8.32 10.47 8.32 12Q8.32 12.88 8.7 13.64Q9.07 14.4 9.78 14.93Q10.25 15.28 10.41 15.84Q10.57 16.4 10.3 16.9Q10.05 17.32 9.6 17.5Q9.15 17.68 8.72 17.43Q7.3 16.55 6.49 15.11Q5.67 13.68 5.67 12Q5.67 9.35 7.51 7.51Q9.35 5.67 12 5.67Q13.68 5.67 15.11 6.5Q16.55 7.33 17.43 8.75Q17.68 9.18 17.5 9.61Q17.32 10.05 16.9 10.3Q16.4 10.57 15.84 10.41Q15.28 10.25 14.93 9.78Q14.4 9.07 13.64 8.7Q12.88 8.32 12 8.32ZM12 4.33Q8.8 4.33 6.56 6.56Q4.33 8.8 4.33 12Q4.33 14.88 6.17 17.01Q8.03 19.15 10.88 19.57Q11.45 19.65 11.84 20.07Q12.22 20.5 12.18 21.07Q12.13 21.6 11.75 21.95Q11.38 22.3 10.88 22.25Q8.93 22.05 7.24 21.16Q5.55 20.27 4.31 18.9Q3.08 17.52 2.38 15.75Q1.68 13.97 1.68 12Q1.68 9.85 2.49 7.97Q3.3 6.1 4.7 4.7Q6.1 3.3 7.99 2.49Q9.88 1.68 12 1.68Q16.05 1.68 19 4.4Q21.95 7.13 22.27 11.15Q22.32 11.63 21.96 11.95Q21.6 12.28 21.1 12.3Q20.52 12.32 20.1 11.91Q19.68 11.5 19.57 10.9Q19.1 8.13 16.98 6.22Q14.85 4.33 12 4.33ZM19.55 21.5L16.25 18.23L15.65 20Q15.5 20.48 15.01 20.48Q14.53 20.48 14.4 20L12.35 13.18Q12.22 12.8 12.51 12.51Q12.8 12.22 13.18 12.35L20 14.4Q20.48 14.53 20.48 15.01Q20.48 15.5 20 15.65L18.23 16.25L21.52 19.55Q21.95 19.98 21.95 20.52Q21.95 21.07 21.52 21.5Q21.1 21.93 20.54 21.93Q19.98 21.93 19.55 21.5Z" fill={color} />
    </svg>
  );
}
